import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const staticLocationTextDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.staticLocation,
  componentType: LAYOUT_COMPONENT_TYPE.staticLocationText,
  registryBlockKey: REGISTRY_BLOCK.presentation.staticLocationText,
  displayOrder: 2,
  content: {
    sectionTitle: loc3('Wo wir stehen', 'Where we park', 'Chúng tôi ở đâu'),
    locationLabel: loc3('Food Truck Spot', 'Food truck spot', 'Điểm food truck'),
    address: loc3(
      'Viktualienmarkt · Standfläche Süd',
      'Viktualienmarkt · South bay',
      'Viktualienmarkt · Khu phía nam',
    ),
    hours: loc3(
      'Di–Sa 11:30–15:00 · So & Mo geschlossen',
      'Tue–Sat 11:30–15:00 · Sun & Mon closed',
      'T3–T7 11:30–15:00 · CN & T2 nghỉ',
    ),
    directions: loc3(
      'Neben dem Blumenstand — folge dem Rauch vom Grill.',
      'Next to the flower stall — follow the grill smoke.',
      'Bên quầy hoa — theo khói nướng.',
    ),
  },
  media: {},
};
